import { useTranslation } from 'react-i18next'

import { ComboBox, Text } from '@reveni-io/reveni-ui'

import { languages } from '@/common/constants'

import * as Styles from './styles'

const SupportedLanguages = ({
  supportedLanguages,
  handleChangeSupportedLanguage,
  defaultLanguage,
  handleChangeDefaultLanguage,
}) => {
  const { t } = useTranslation()

  const getSupportedLanguages = () => {
    return languages(t)?.filter(lang => supportedLanguages?.includes(lang.value))
  }

  return (
    <Styles.Container>
      <Text type="titleM" tag="h3" customStyles={{ fontWeight: 600 }}>
        {t('Idiomas soportados')}
      </Text>
      <Text type="bodyMRegular">
        {t(
          'Selecciona los idiomas en los estará disponible el portal de cambios y devoluciones. Los clientes podrán escoger entre los idiomas habilitados para completar el proceso y recibir comunicaciones.'
        )}
      </Text>
      <ComboBox
        label={t('Idiomas soportados')}
        menuItems={languages(t)}
        value={supportedLanguages || []}
        handleChange={handleChangeSupportedLanguage}
        multiple
        fullWidth
      />
      <ComboBox
        label={t('Idioma por defecto')}
        placeholder={t('Seleccionar idioma por defecto...')}
        menuItems={getSupportedLanguages()}
        value={defaultLanguage}
        handleChange={e => handleChangeDefaultLanguage(e.target.value)}
        disabled={supportedLanguages?.length === 0}
        fullWidth
      />
    </Styles.Container>
  )
}

export default SupportedLanguages
